import { AuthXUserIdentityToken } from '@/types'
import { request } from '@/store/client'
import { nrRedirectToProduct } from '../newrelic'

export const loginViaAuthXSSO = async (token: string, partnerCode: string) => {
  return generatePartnerSsoToken(token, partnerCode)
    .then(({ token: partnerSsoToken, tenantCode }) => {
      window.location.assign(generateRedirectURI(partnerSsoToken, tenantCode))
    })
}

export const generatePartnerSsoToken = async (token: string, partnerCode: string): Promise<AuthXUserIdentityToken> => {
  return request({
    url: `/partners/${encodeURIComponent(partnerCode)}/generate-token`,
    method: 'post',
    data: {
      token,
    },
  })
    .then(response => {

      nrRedirectToProduct()

      return response.data

    })
}

export const generateRedirectURI = (code: string, tenantCode: string): string => {
  const url = new URL(`${window.location.protocol}//${window.location.host}/authenticate`)

  url.searchParams.append('code', code)
  url.searchParams.append('tenantCode', tenantCode)
  url.searchParams.append('state', 'authx')

  return url.toString()
}
